import Axios from 'axios';
import config from '../config';
import { CHANGE_COUNTS } from '../reducers/counts';

function changeCountsType(counts: string) {
    return {
        type: CHANGE_COUNTS,
        payload: counts
    };
}

export function changeCounts(text: string) {
    return (dispatch: any) => {
        return Axios.get(`${config.api}/auth/counts`).then((res) => {
            dispatch(changeCountsType(res.data));
        });
    }
}
